import { render, staticRenderFns } from "./ClosedSale.vue?vue&type=template&id=18d81142"
import script from "./ClosedSale.vue?vue&type=script&lang=js"
export * from "./ClosedSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports